import { Button } from '@material-ui/core';
import { ICustomButton } from './CustomButtonTypes';
import React from 'react';
import { customButtonStyles } from './CustomButton.styles';
import { isKidsOrJunior } from '../../../common/utils/activeMenus';
import { globalStyles } from '../../../styles/global.styles';

const getButtonProps = (buttonType: string, selected?: boolean) => {
	const classes = customButtonStyles();
	const isKids = isKidsOrJunior();
	let selectedClass = '';

	if (selected) {
		selectedClass = isKids ? classes.selectorSelectedKids : classes.selectorSelected;
	}

	switch (buttonType) {
		case 'primary':
			return {
				className: classes.primary,
			};
		case 'primaryNotifications':
			return {
				className: classes.primaryNotifications,
			};
		case 'primaryNotificationsAccept':
			return {
				className: classes.primaryNotificationsAccept,
			};
		case 'secondary':
			return {
				className: classes.secondary,
			};
		case 'secondaryNotifications':
			return {
				className: classes.secondaryNotifications,
			};
		case 'alta-bizum':
			return {
				className: classes.altaBizum,
			};
		case 'baja-bizum':
			return {
				className: classes.bajaBizum,
			};
		case 'send-SMS':
			return {
				className: classes.sendSMS,
			};
		case 'bizum':
			return {
				className: classes.bizum,
			};
		case 'depositDesktop':
			return {
				className: `${classes.depositDesktop} ${selectedClass}`,
			};
		case 'depositMovil':
			return {
				className: `${classes.depositMovil} ${selectedClass}`,
			};
		case 'selectorDesktop': {
			const desktopClass = isKids ? classes.selectorDesktopKids : classes.selectorDesktop;
			return {
				className: `${desktopClass} ${selectedClass}`,
			};
		}
		case 'selectorMovil': {
			const mobileClass = isKids ? classes.selectorMobileKids : classes.selectorMovil;
			return {
				className: `${mobileClass} ${selectedClass}`,
			};
		}
		case 'searchButton':
			return {
				className: classes.searchButton,
			};
		case 'backhome':
			return {
				className: classes.backHomeButton,
			};
		case 'deleteButton':
			return {
				className: classes.deleteButton,
			};
		case 'newDeleteButton':
			return {
				className: classes.newDeleteButton,
			};
		case 'actionsButton':
			return {
				className: classes.actionsButton,
			};
		case 'redCancelButton':
			return {
				className: classes.redCancelButton,
			};
		case 'newRedButton':
			return {
				className: classes.newRedButton,
			}
		default:
			return {};
	}
};

const CustomButton: React.FC<ICustomButton> = ({
	text,
	buttonType,
	icon,
	classes,
	selected,
	...otherProps
}) => {
	const buttonProps = getButtonProps(buttonType, selected);
	const globalClasses = globalStyles();

	return (
		<Button
			className={`
				${buttonProps.className}
				${classes}
				${isKidsOrJunior() && globalClasses.juniorKidShadow}
				${isKidsOrJunior() && globalClasses.textWhite}
			`}
			variant={'contained'}
			startIcon={icon}
			{...otherProps}
		>
			{text}
		</Button>
	);
};

export default CustomButton;
